module.exports = __webpack_public_path__ + "static/media/GregorySmelkovContractLogixRecommendation.3ee3deed.pdf";